import { render } from "./PriceTable.vue?vue&type=template&id=98a5b452&scoped=true"
import script from "./PriceTable.vue?vue&type=script&scoped=true&lang=js"
export * from "./PriceTable.vue?vue&type=script&scoped=true&lang=js"

import "./PriceTable.vue?vue&type=style&index=0&id=98a5b452&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98a5b452"]])

export default __exports__